import { createFileRoute } from "@tanstack/react-router";

import { DeleteAccountPage } from "src/pages/DeleteAccountPage";

export const Route = createFileRoute("/_public/delete-account")({
  component: DeleteAccountPage,
  ssr: true,
});
